module.exports = __webpack_public_path__ + "img/change.71664a03.svg";